import { AtomServiceExportData } from '@/app/editor/iframe/atom/atom-service/export/AtomServiceExportData';
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import type { AtomModel, Font, TypeSettings } from '@/app/editor/iframe/atom/Atom.model';

import { Atom } from '@/app/editor/iframe/atom/Atom';
import HELPER from '@/app/utils/HELPER';
import STORE from '@/app/store/store';
import atom from '@/app/editor/iframe/atom';
import { checkKeyValid } from '@/app/utils/checkRoleApply';
import { convertProductFormHtmlToLiquid } from '@/app/utils/helpers';
import ProductAtomRender from '@/app/editor/iframe/atom/atom-service/render/ProductAtomRender';
import type { AtomRenderHook } from '@/app/editor/iframe/atom/atom-interface/AtomRenderInterface';
import { DataManager } from '@/app/editor/iframe/atom/service/DataManager';

/**
 * GpProductExportService
 */
class GpProductExportService extends AtomServiceExportData {
  /**
   * renderTemplateExport
   * @param $atomClone :any
   * @param html :string
   * @param exportType :string
   * @returns $atomClone :JQuery
   */
  renderTemplateExport($atomClone: any, html: string, exportType: string): JQuery {
    // VERSION 3 and greater, support {% form 'product' %} and Dynamic Checkout Button
    const dataVer: any = $atomClone.attr('data-ver');
    const version = $atomClone.attr('data-ver') != undefined ? parseFloat(dataVer) : 0;
    const $form = $atomClone.find('form');

    const pHandle = $atomClone.find('.module').attr('data-pHandle');
    let liquid = '';

    const gType = this.atom.$gfFrame.data('gfframe').getPageType();
    const $parentModule = this.atom.$gryffBody.find(this.atom.getId()).parent().closest('.module-wrap');

    // PRODUCT DESIGN
    if ($parentModule.attr('data-label') != 'Product List' && $parentModule.attr('data-label') != 'Related Products') {
      if ($atomClone.attr('data-status') != 'default' && $atomClone.attr('data-status') != 'dynamic') {
        if (exportType != 'block') {
          // VERSION 3
          if (version >= 3) {
            // $form.prepend("{% assign product = all_products['" + pHandle + "'] %}");
            $form.before("{% assign product = all_products['" + pHandle + "'] %}");
          } else {
            liquid += "{% assign product = all_products['" + pHandle + "'] %}";
          }
        }
      }
    }
    liquid +=
      '<input name="id" type="hidden" value="{{product.selected_or_first_available_variant.id}}" data-productid="{{product.id}}">';
    $form.prepend(liquid);

    liquid = '{% unless product == empty %}';

    // no more hidden variant input in version 3.1 or above
    if (version <= 3) {
      liquid += '{% for variant in product.variants %}';
      liquid +=
        '<input type="hidden" id="gf-hidden-variant{{variant.id}}" value="{{variant.id}}" data-compare-price="{{ variant.compare_at_price | money | strip_html }}" data-price="{{ variant.price | money | strip_html }}"/>';
      liquid += '{% endfor %}';
    }

    liquid += '<script type="text/plain" class="product-json" id="product-json{{product.id}}">';
    liquid += '{{ product | json }}';
    liquid += '</script>';
    liquid += '{% endunless %}';

    $form.append(liquid);
    $form.attr('data-productid', '{{product.id}}');

    // backup product variable
    if (gType == 'template-product') {
      if (
        $parentModule.attr('data-label') != 'Product List' &&
        $parentModule.attr('data-label') != 'Related Products'
      ) {
        liquid = '{% assign currentProduct = product %}';
        $atomClone.prepend(liquid);

        liquid = '{% assign product = currentProduct %}';
        $atomClone.append(liquid);
      }
    }

    // remove attributes
    $atomClone
      .find('.module')
      .removeAttr('data-product')
      .removeAttr('data-phandle')
      .removeAttr('data-pid')
      .removeAttr('data-index');

    // VERSION 3
    if (version >= 3) {
      //testing function convertProductFormHtmlToLiquid
      if (checkKeyValid('productToLiquid')) {
        let tmpHtml = $atomClone.html();
        const formId = $form.attr('id');
        const formClass = $form.attr('class');

        tmpHtml = convertProductFormHtmlToLiquid(tmpHtml, formId, formClass);
        return $atomClone.html(tmpHtml);
      } else {
        //old code
        let tmpHtml: any = $atomClone.html();
        const regex = '<form(.*?>)';
        if (tmpHtml.match(regex)) {
          const matched = tmpHtml.match(regex)[0].replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          const matchedString = new RegExp(matched, 'g');

          const formId = $form.attr('id');
          const formClass = $form.attr('class');
          tmpHtml = tmpHtml.replace(
            matchedString,
            "{% unless product.empty?  %}{% form 'product', product, id: \"" +
              formId +
              '", class: "' +
              formClass +
              '", data-productid: product.id %}',
          );

          tmpHtml = tmpHtml.replace('</form>', '{% endform %}{% endunless %}');
        }
        return $atomClone.html(tmpHtml);
      }
    }
    return $atomClone;
  }

  /**
   * @override get$bkCloneHtml
   * @param $bkClone $bkClone
   * @returns returns
   */
  get$bkCloneHtml($bkClone: JQuery): JQuery {
    const $bk = jQuery('<div />').append($bkClone);
    const atomModel = DataManager.getDataSetting(this.atom.getId()).atom;
    const settingsString = JSON.stringify(atomModel.settings);
    $bk.find('.settings').html(settingsString);
    return $bk;
  }
}
/**
 * Hero Banner Atom Module
 */
export class GpProduct extends Atom implements AtomRenderHook {
  public $el: JQuery;
  public atomRender: ProductAtomRender;

  /** constructor
   * @param element DOM
   * @param options Seting
   */
  constructor(element: HTMLElement, options?: TypeSettings) {
    super(element, options);
    STORE.setValue(`product-${this.data.atom.id}-change-product`, false);
  }

  /**
   * Thông tin riêng của Atom
   * @returns object watch
   */
  getDataAtom(): AtomModel {
    const data: AtomModel = {
      type: this.getType(),
      id: this.getId(),
      nodeId: this.getIdNode(),
      name: 'Product',
      slug: 'product',
      groupName: 'Module',
      settings: this.getSettings(),
      data: this.getDataChilds(),
      html: this.getTemplate(),
      class: '.module-wrap',
      style: this.getStyle(),
      script: this.getScript(),
      libs: this.getLibs(),
      fonts: [] as Array<Font>,
      formControlSettings: [
        {
          type: 'product:pick',
          name: 'pid',
          property: 'data-pid',
          targetSelector: '.module',
        },
        {
          type: 'html:attr',
          name: 'formId',
          targetSelector: '.AddToCartForm',
          property: 'id',
        },
        {
          type: 'html:extraClass',
          name: 'extraClass',
          targetSelector: '.AddToCartForm',
          property: 'data-exc',
        },
      ],
      version: 1,
    };
    return data;
  }

  /**
   * @override initAtomRender
   */
  initAtomRender() {
    const atomRender = new ProductAtomRender(this);
    this.atomRender = atomRender;
  }

  /**
   * @override initAtomRender
   */
  // async render() {
  //   return this.atomRender.renderByQueue();
  // }

  /**
   * @override Atom.getDataChilds
   * @returns data childs
   */
  getDataChilds() {
    if (this.data.notInitChildren) {
      return {
        items: [
          {
            content: '<span class="gf_add-content"><span class="gf_add-content-span"></span></span>',
          },
        ],
      };
    }
    return super.getDataChilds();
  }

  /**
   * @override Atom.afterRender
   */
  afterRender() {
    const isChangeProduct: boolean = STORE.getValue(`product-${this.data.atom.id}-change-product`);

    if (isChangeProduct) {
      // update variant setting in sidebar
      const $sidebarVariantSetting = jQuery('input#variant.gf-field-item');

      // remove old Variant options
      if ($sidebarVariantSetting.data('gfvariantselector')) {
        const oldSelectors = $sidebarVariantSetting.siblings('div.gryff_layout-onion');
        oldSelectors.remove();

        $sidebarVariantSetting.removeData('gfvariantselector');
      }

      // set new Variant options
      ($sidebarVariantSetting as any).gfVariantSelector({
        /**
         * gfVariantSelector.detectChange
         */
        detectChange: function () {},
      });

      // finish update variant setting in sidebar
      STORE.setValue(`product-${this.data.atom.id}-change-product`, false);
    }

    if (this.data.notInitChildren) {
      this.initChildForBlankTemplate();
    }
  }

  /**
   * only use with blank template
   * init child after render product
   */
  initChildForBlankTemplate() {
    const items = [
      {
        label: 'Row',
        settings: {
          'gf_row-layout': '6+6',
          'gf_row-layout-md': '6+6',
          'gf_row-layout-sm': '6+6',
          'gf_row-layout-xs': '6+6',
        },
        items: [
          {
            label: '(P) Image',
            settings: {
              width: '100%',
            },
            placeholder: 0,
          },
          {
            label: '(P) Image List',
            placeholder: 0,
          },
          {
            label: '(P) Title',
            settings: {
              align_lg: 'left',
              align_md: 'left',
              align_sm: 'left',
              align_xs: 'left',
            },
            placeholder: 1,
          },
          {
            label: '(P) Price',
            settings: {
              align_lg: 'left',
              align_md: 'left',
              align_sm: 'left',
              align_xs: 'left',
            },
            placeholder: 1,
          },
          {
            label: '(P) Swatches',
            settings: {
              align_lg: 'left',
              align_md: 'left',
              align_sm: 'left',
              align_xs: 'left',
            },
            placeholder: 1,
          },
          {
            label: '(P) Quantity',
            settings: {
              align_lg: 'left',
              align_md: 'left',
              align_sm: 'left',
              align_xs: 'left',
            },
            placeholder: 1,
          },
          {
            label: '(P) Cart Button',
            settings: {
              align_lg: 'left',
              align_md: 'left',
              align_sm: 'left',
              align_xs: 'left',
            },
            placeholder: 1,
          },
        ],
      },
    ];

    const $placeHolder = this.$el.find('.block-placeholder');
    HELPER.addSnippetToEditor(items, items.length - 1, $placeHolder);
  }

  /**
   * renderChilds inside Product wrapper
   */
  renderChilds(): void {
    const _this = this;
    this.$el.find('.item-content').each(function () {
      const $itemContent = jQuery(this);
      const initCondition = $itemContent.closest('.module-wrap').is(_this.$el);
      if (initCondition) {
        const $childs = $itemContent.children('.gf_row, .module-wrap, .element-wrap');
        if ($childs && $childs.length) {
          for (let i = 0; i < $childs.length; i++) {
            const $child = $childs[i];
            atom.Init(jQuery($child));
          }
        }
      }
    });

    return;
  }
  /**
   * override getLabel từ Atom
   * @returns Name
   */
  getLabel(): string {
    return this.$el.attr('data-label') || 'Product';
  }
  /**
   * override getLabel từ Atom
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-slug') || 'product';
  }
  /**
   * get Dât from html attr
   * @returns Group Name
   */
  getGroupName(): string {
    return this.$el.attr('data-groupname') || 'Module';
  }

  /**
   * @override Atom.initAtomExport
   */
  initAtomExport() {
    this.atomServiceExportData = new GpProductExportService(this);
  }
}
